import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import * as Constant from '.././Constant/Constant';

const PrivateRoute = ({component: Component, ...rest}) => {
    return (

        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={props => (
            localStorage.getItem(Constant.LOCAL_STORAGE_USER_KEY) ?
                <Component {...props} />
            : <Redirect to="/login" />
        )} />
    );
};

export default PrivateRoute;